var page = {
	folder: "",
	isFirst: true,
	init: function(){
		page.checkURL();
		common.nav();
		setTimeout(function(){
			$("body").removeClass("disable");
		},600);
	},
	changeURL: function(path){
		page.current = path;
		window.history.pushState(null, null, path);
		page.checkURL();
	},
	nav: function(){
		$("a.btn_online").off().on("click", function(){
			let url = $(this).attr("data-name");
			sendClickEvent(url);
		});
		$("a.btn_amazon").off().on("click", function(){
			let url = $(this).attr("data-name");
			sendClickEvent(url);
		});
		function sendClickEvent(name){
			var label = isLang + ": " + name;
			console.log(label)
			gtag('event', 'click', { 'event_category': 'product', 'event_label': label});
		}
	},
	changePage: function(){
		//console.log("change Page");
		page.afterChangePage();
	},
	afterChangePage: function(){
		//console.log("after change Page");
		if(page.isFirst){
			page.isFirst = false;
		}
		page.nav();
		var canonicals = page.getCanonicalURL();
	},
	getCanonicalURL: function(){
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			if (links[i].rel) {
				if (links[i].rel.toLowerCase() == "alternate") {
					return links[i].href;
				}
			}
		}
		return null;
	},
	checkURL: function(){
		let url 	= location.href,
			prop 	= location.pathname,
			arry 	= prop.split("/"),
			len 	= arry.length,
			baseNum = 2;
		//console.log(arry, len, arry[1]);
		if(arry[1] === "en"){
			isLang = "en";
			baseNum = 3;
		}else{
			isLang = "ja";
			baseNum = 2;
		}
		//console.log(baseNum, len)
		if($html.classList.contains("is_404")){

		}else{
			if(page.isFirst){
				if(len === baseNum){
					page.folder = "";
					//product.init();
				}else if(len === baseNum+1 || len === baseNum+2|| len > baseNum+2){
					if(isLang === "ja"){
						page.folder = arry[1];
					}else{
						page.folder = arry[2];
					}
					if(page.folder === "product"){
						//product.init();
						//product.makeChart();
					}else if(page.folder === "dictionary"){
						//dic.init();
					}else if(page.folder === "news"){
						//news.init();
						//newsSlide.init();
					}
				}
			}else{
				if(len === baseNum){
					if($html.classList.contains("product")){
						//トップに戻る
						product.closeDetail();
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}else{

					}
				}else if(len === baseNum+1){
					if(page.folder === "dictionary"){
						dic.closePage();
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}else if(page.folder === "news"){
						news.closePage();
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}
				}else if(len === baseNum+1 || len > baseNum+1){
					if(isLang === "ja"){
						page.folder = arry[1];
					}else{
						page.folder = arry[2];
					}
					if(page.folder === "product"){
						//console.log("product, ")
						product.loadPage(prop);
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}else if(page.folder === "dictionary"){
						dic.loadPage(prop);
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}else if(page.folder === "news"){
						news.loadPage(prop);
						gtag('config', 'UA-151202698-1', {
							'page_location': location.href,
							'page_path': location.pathname
						});
					}
				}
			}
		}
		
		page.changePage();
	}
}